import { useState, useEffect } from "react";
import { getCompareImages } from "../utils/helpers";
import type { CarDataType } from "../../../../common-deprecated/features/compare/utils/newCarCompareTypes";
import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";

type useCompareDetailsReturnType = {
    placeholderImage: string;
    swatchSelectHeight: number;
    setSwatchSelectHeight: (height: number) => void;
    engineSelectHeight: number;
    setEngineSelectHeight: (height: number) => void;
};

const useCompareDetails = (
    isPdf: boolean,
    cars: CarDataType[],
    settings: CommonSettingsType,
): useCompareDetailsReturnType => {
    const [swatchSelectHeight, setSwatchSelectHeight] = useState<number>(isPdf ? 16 : 0);
    const [engineSelectHeight, setEngineSelectHeight] = useState<number>(isPdf ? 90 : 0);

    const notAllCarsAreLoaded = !!cars.filter((car) => car.loading).length;

    // Don't update placeholderimage after first selection
    const [placeholderImage, setPlaceholderImage] = useState("");

    useEffect(() => {
        if (!notAllCarsAreLoaded && !placeholderImage) {
            const lastLoadedCar = cars.filter((car) => !car.loading).reverse()[0];
            setPlaceholderImage(getCompareImages(lastLoadedCar, settings).default);
        }
    }, [notAllCarsAreLoaded]);

    return {
        placeholderImage,
        swatchSelectHeight,
        setSwatchSelectHeight: (height: number) => setSwatchSelectHeight(height),
        engineSelectHeight,
        setEngineSelectHeight: (height: number) => setEngineSelectHeight(height),
    };
};

export default useCompareDetails;
